module.exports = __webpack_public_path__ + "img/icon-emot.70172233.svg";